<template>
  <div class="modal">
    <div class="background-overlay"></div>
    <Loader v-if="$apolloData.loading" />
    <div v-else class="message-container">
      <div @click="$emit('close')" class="modal-close">
        <CloseIcon />
      </div>
      <div class="modal-content">
        <div class="top">
          <div class="title">
            <span class="card-title">Drop Settings</span>
          </div>
        </div>
        <div class="drop-settings">
          <label class="switch settings">
            <input
              v-model="emails_enabled"
              type="checkbox"
              class="switch-input"
              checked
            />
            <span
              class="switch-background"
              data-on="On"
              data-off="Off"
            ></span>
            <span class="switch-handle"></span>
            <span class="switch-label">Send subscribers automatic emails for new releases</span>
          </label>
          <label class="switch settings">
            <input
              v-model="sms_enabled"
              type="checkbox"
              class="switch-input"
              checked
            />
            <span
              class="switch-background"
              data-on="On"
              data-off="Off"
            ></span>
            <span class="switch-handle"></span>
            <span class="switch-label">Send subscribers automatic text messages for new releases</span>
          </label>
        </div>
        <div class="buttons">
          <button
            class="button-default"
            @click="submit"
            :disabled="submitting"
          >
            {{ submitting ? "Submitting..." : "Update" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "../../../public/img/icons/close.svg";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";

import Loader from "@/components/Custom/Loader";

import {
  Q_DROP_SETTINGS,
  M_UPDATE_DROP_SETTINGS
} from "@/graphql";

export default {
  name: "DropSettings",
  components: {
    CloseIcon,
    Loader
  },
  data() {
    return {
      emails_enabled: false,
      sms_enabled: false,
      submitting: false
    };
  },
  apollo: {
    drop_settings: {
      query: Q_DROP_SETTINGS,
      fetchPolicy: "network-only",
      variables() {
        return {
          artist_id: this.artist.id
        };
      },
      result({ data }) {
        this.emails_enabled = data.drop_settings.emails_enabled;
        this.sms_enabled = data.drop_settings.sms_enabled;
      }
    }
  },
  computed: {
    artist() {
      return this.$store.getters.getArtist;
    }
  },
  methods: {
    async submit() {
      this.submitting = true;
      await this.$apollo.mutate({
        mutation: M_UPDATE_DROP_SETTINGS,
        variables: {
          artist_id: this.artist.id,
          emails_enabled: this.emails_enabled,
          sms_enabled: this.sms_enabled
        }
      });
      this.submitting = false;
      this.$emit("close");
    },
  }
};
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .message-container {
    margin: 10px;
    padding: 60px 0 0;
    width: 680px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    backdrop-filter: blur(23px);
    border-radius: 10px;

    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;

      &:hover {
        svg {
          path {
            fill: white;
          }
        }

        .close-text {
          color: white;
        }
      }

      svg {
        width: 24px;

        path {
          fill: #8786ab;
        }
      }
    }

    .modal-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 40px 40px;

      .top {
        display: flex;
        justify-content: space-between;
        width: 100%;

        .title {
          display: flex;
          flex-direction: column;

          .card-title {
            font-size: 18px;
            font-weight: 600;
            color: white;
          }

          .card-text {
            font-size: 14px;
            font-weight: 400;
            color: $text-type-0;
            margin-bottom: 30px;
          }
        }
      }

      .drop-settings {
        display: flex;
        flex-direction: column;
        margin: 20px 0;
        width: 100%;

        .settings {
          grid-area: settings;
          margin-top: 20px;
        }

        label,
        .label {
          margin-left: 5px;
          font-weight: bold;
          line-height: 15px;
          font-size: 14px;
          font-weight: 400;
        }
      }

      .buttons {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        height: 40px;
        width: 100%;

        button {
          margin-left: 10px;

          &:first-child {
            margin-left: 0;
          }

          svg {
            margin: 0;
            margin-right: 5px;
          }
        }
      }
    }
  }

  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    backdrop-filter: blur(10px) !important;
  }
}
</style>
